<template>
  <div :class="['user-roles__datasources__list', { multiEdit, isLocalAdmin }]">
    <r-text v-if="activeUserState">
      {{ $t("datasources:title-activeuser-ds") }}
    </r-text>
    <r-text v-else>{{ $t("datasources:title-user-ds") }}</r-text>
    <div class="user-roles__datasources__controls-row">
      <div class="user-roles__datasources__controls-col">
        <r-search-input
          :filter-text="filterText"
          @change="e => filterChange(e)"
        />
      </div>
    </div>
    <ul
      class="user-roles__datasources__list-wrapper"
      v-if="filteredDatasources.length || filteredSecondaryDs.length"
    >
      <li
        :class="[
          'user-roles__datasources__list-item',
          { active: isActiveDs(ds.id) },
          { disabled: !activeCruds.length && multiEdit && !isLocalAdmin }
        ]"
        v-for="ds in filteredDatasources"
        :key="ds.id"
        @click="toggleSourcename(ds)"
      >
        <div class="user-roles__datasources__list-item__content">
          <r-text>{{ ds.name }}</r-text>
          <r-text type="caption">
            {{ getCruds(ds) }}
          </r-text>
        </div>
        <div class="user-roles__datasources__list-item__controls">
          <div
            :class="[
              'user-roles__datasources__list-item__controls-item',
              { active: isCrudActive(ds, crud.prop) }
            ]"
            v-for="crud in crudsItems"
            :key="crud.id"
            @click="toggleCrud($event, ds, crud.prop)"
          >
            <i :class="`el-icon-${crud.icon}`" />
          </div>
        </div>
      </li>
      <div
        class="r-row-separator"
        v-if="filteredDatasources.length && filteredSecondaryDs.length"
      />
      <r-title
        type="subtitle-2"
        v-if="filteredSecondaryDs.length"
        style="padding: 0;"
      >
        {{ $t("datasources:title-activeuser-ds-nonmanaged")
        }}{{ activeUser.name }}
      </r-title>
      <li
        class="user-roles__datasources__list-item secondary"
        v-for="ds in filteredSecondaryDs"
        :key="ds.id"
      >
        <div class="user-roles__datasources__list-item__content">
          <r-text>{{ ds.name }}</r-text>
          <r-text type="caption">
            {{ getCruds(ds) }}
          </r-text>
        </div>
        <div class="user-roles__datasources__list-item__controls">
          <div
            :class="[
              'user-roles__datasources__list-item__controls-item',
              { active: isCrudActive(ds, crud.prop) }
            ]"
            v-for="crud in crudsItems"
            :key="crud.id"
          >
            <i :class="`el-icon-${crud.icon}`" />
          </div>
        </div>
      </li>
    </ul>
    <ul class="user-roles__datasources__list-wrapper" v-else>
      <div class="user-roles__datasources__list-no-data">
        <r-text v-if="!filterText.trim()">{{
          $t("datasources:no-data")
        }}</r-text>
        <r-text v-else>{{ $t("datasources:filter-no-data") }}</r-text>
      </div>
    </ul>
  </div>
</template>

<script>
import { crudsArray } from "../../../configs";

export default {
  props: {
    datasources: { type: Array, default: () => [] },
    multiEdit: { type: Boolean },
    crudsArray: { type: Array, default: () => [] },
    secondaryDs: { type: Array, default: () => [] },
    activeUserState: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      crudsItems: crudsArray,
      filterText: ""
    };
  },
  computed: {
    userDS() {
      return this.$store.state.userRoles.activeUserDS;
    },
    crudsParams() {
      const crudsParams = {};
      this.crudsArray.forEach(e => (crudsParams[e.prop] = e.value));
      return crudsParams;
    },
    activeCruds() {
      const activeCruds = [];
      this.crudsArray
        .filter(e => e.value)
        .forEach(e => activeCruds.push(e.prop));
      return activeCruds;
    },
    initialUserDS() {
      return this.$store.state.userRoles.initialUserDS;
    },
    activeUser() {
      return this.$store.state.userRoles.activeUser;
    },
    isLocalAdmin() {
      return this.$store.state.userRoles.activeUser.local_admin || false;
    },
    filteredDatasources() {
      return this.datasources.filter(
        e =>
          e.name.toLowerCase().indexOf(this.filterText.toLowerCase().trim()) >
          -1
      );
    },
    filteredSecondaryDs() {
      return this.secondaryDs.filter(
        e =>
          e.name.toLowerCase().indexOf(this.filterText.toLowerCase().trim()) >
          -1
      );
    }
  },
  methods: {
    filterChange(e) {
      this.filterText = e;
    },
    getCruds(ds) {
      const module = this.userDS.find(e => e.id === ds.id);
      let message = "";

      this.crudsArray.forEach(e => {
        if (module && module._action !== "deleted" && module[e.prop])
          message += ` ${this.$t(`crud:${e.prop}`)}`;
      });

      return message;
    },
    isActiveDs(id) {
      const module = this.userDS.find(e => e.id === id);

      return !!(module && module._action !== "deleted");
    },
    isCrudActive(ds, crud) {
      return this.getCruds(ds).indexOf(this.$t(`crud:${crud}`)) >= 0;
    },
    toggleCrud(e, ds, crud) {
      e.stopPropagation();
      if (this.isLocalAdmin) return;
      const crudValue = !!(
        this.getCruds(ds).indexOf(this.$t(`crud:${crud}`)) >= 0
      );

      this.toggleSourcename(ds, { name: crud, value: !crudValue });
    },
    toggleCurrentCrud(
      current,
      currentCrud,
      datasource,
      isExistBefore,
      crudsParams,
      multi = false
    ) {
      if (datasource) {
        let isActiveBefore;

        if (multi) {
          const isActive = !!this.activeCruds.find(e => !datasource[e]);
          this.activeCruds.forEach(e => {
            datasource[e] = isActive;
          });
          isActiveBefore = !!this.crudsArray.find(e => datasource[e.prop]);
        } else {
          datasource[currentCrud.name] = currentCrud.value;
          isActiveBefore = !!this.crudsItems.find(e => datasource[e.prop]);
        }

        if (!isActiveBefore) {
          if (isExistBefore) {
            datasource._action = "deleted";
          } else {
            let index = this.userDS.findIndex(
              item => item.id === datasource.id
            );
            this.userDS.splice(index, 1);
          }
        } else {
          datasource._action = undefined;
        }

        if (
          datasource._action !== "created" &&
          datasource._action !== "deleted"
        ) {
          if (isExistBefore) {
            datasource._action = "updated";
          } else {
            datasource._action = "created";
          }
        }
      } else {
        this.userDS.push({
          ...current,
          _action: "created",
          ...crudsParams
        });
      }
    },
    toggleSourcename(current, currentCrud) {
      if (
        this.multiEdit &&
        !this.crudsArray.find(e => e.value) &&
        !this.isLocalAdmin
      )
        return;
      const datasource = this.userDS.find(item => item.id === current.id);
      const isExistBefore = datasource
        ? !!this.initialUserDS.find(e => e.id === datasource.id)
        : false;

      if (current.children && current.children.length) {
        current.children.forEach(ds => this.toggleSourcename(ds, currentCrud));
      }
      if (currentCrud) {
        const crudsParams = {
          create: false,
          read: false,
          update: false,
          delete: false,
          share: false,
          export: false
        };

        crudsParams[currentCrud.name] = currentCrud.value;

        this.toggleCurrentCrud(
          current,
          currentCrud,
          datasource,
          isExistBefore,
          crudsParams
        );
      } else if (this.multiEdit) {
        if (this.isLocalAdmin) {
          this.toggleCurrentCrud(
            current,
            currentCrud,
            datasource,
            isExistBefore,
            {
              create: true,
              read: true,
              update: true,
              delete: true,
              share: true,
              export: true
            },
            true
          );
        } else {
          this.toggleCurrentCrud(
            current,
            currentCrud,
            datasource,
            isExistBefore,
            this.crudsParams,
            true
          );
        }
      } else {
        if (datasource) {
          const isCrudsValid = !!this.crudsArray.find(e => datasource[e.prop]);
          let index;

          switch (datasource._action) {
            case "deleted":
              datasource._action = undefined;
              if (this.isLocalAdmin) {
                datasource.create = true;
                datasource.read = true;
                datasource.update = true;
                datasource.delete = true;
                datasource.share = true;
                datasource.export = true;
              }
              break;
            case "created":
              index = this.userDS.findIndex(item => item.id === datasource.id);
              this.userDS.splice(index, 1);
              break;
            default:
              datasource._action = "deleted";
          }
          if (!isCrudsValid) datasource.read = true;
        } else {
          if (this.isLocalAdmin) {
            this.userDS.push({
              ...current,
              _action: "created",
              create: true,
              read: true,
              update: true,
              delete: true,
              share: true,
              export: true
            });
          } else {
            this.userDS.push({
              ...current,
              _action: "created",
              create: false,
              read: true,
              update: false,
              delete: false,
              share: false,
              export: false
            });
          }
        }
      }
    }
  }
};
</script>

<style lang="scss">
.user-roles__datasources__list {
  position: relative;
  overflow: hidden;
  padding: 4px;
  width: 100%;
  max-width: 520px;
  margin-right: 12px;
  &:last-child {
    margin-right: 0;
  }
  &.multiEdit {
    .user-roles__datasources__list-wrapper {
      height: calc(100vh - 400px);
    }
  }
  &-wrapper {
    padding: 4px;
    box-sizing: border-box;
    border-radius: var(--border-radius);
    border: 1px solid;
    border-color: var(--dividers_low_contrast) !important;
    overflow: auto;
    height: calc(100vh - 312px);
  }
  &-item {
    display: flex;
    align-items: center;
    position: relative;
    border-radius: var(--border-radius);
    width: 100%;
    height: 42px;
    padding: 6px 24px;
    box-sizing: border-box;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin-bottom: 2px;
    cursor: pointer;
    &:last-child {
      margin-bottom: 0;
    }
    &.active {
      background-color: var(--accent_selected) !important;
      color: var(--accent_primary);
      &:before {
        content: "";
        display: block;
        position: absolute;
        height: 4px;
        width: 8px;
        border-bottom: 1px solid;
        border-left: 1px solid;
        border-color: var(--accent_primary);
        transform: rotate(-45deg) translateY(-50%);
        left: 12px;
        top: 45%;
      }
    }
    &:hover {
      background-color: var(--accent_selected) !important;
      .user-roles__datasources__list-item__controls {
        display: flex;
      }
    }
    &:active {
      background-color: var(--accent_selected) !important;
    }
    &.disabled {
      cursor: not-allowed !important;
    }
    &__content {
      width: 100%;
      display: flex;
      overflow: hidden;
      flex-direction: column;
      .r-text {
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    &__controls {
      display: none;
      align-items: center;
      padding: 4px;
      height: 100%;
      box-sizing: border-box;
      cursor: default;
      &-item {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 2px;
        border-radius: var(--border-radius);
        overflow: hidden;
        i {
          font-size: 12px;
          padding: 4px;
        }
        &:last-child {
          margin-right: 0;
        }
        &.active {
          color: var(--white_white);
          background-color: var(--accent_primary);
        }
        &:hover {
          cursor: pointer;
          color: rgba(var(--white_white), 0.5);
          background-color: var(--accent_selected) !important;
        }
      }
    }
    &.secondary {
      cursor: not-allowed !important;
      &:hover,
      &:active {
        background-color: var(--accent_selected) !important;
      }
      .user-roles__datasources__list-item__controls {
        cursor: not-allowed !important;
        &-item {
          cursor: not-allowed !important;
          &.active {
            color: var(--white_white) !important;
            background-color: var(--accent_primary) !important;
          }
        }
      }
    }
  }
  &-no-data {
    text-align: center;
    padding: 40px 20px;
  }
  &.isLocalAdmin {
    .user-roles__datasources__list-wrapper {
      height: calc(100vh - 284px);
    }
    .user-roles__datasources__list-item {
      &:hover {
        .user-roles__datasources__list-item__controls {
          display: flex;
        }
      }
      &__controls {
        cursor: default;
        &-item {
          color: var(--text_secondary) !important;
          &.active {
            color: var(--white_white) !important;
            background-color: var(--accent_primary) !important;
          }
          &:hover {
            cursor: default;
            color: initial;
            background-color: initial;
          }
        }
      }
    }
  }
  .r-module-title {
    margin-bottom: 8px;
  }
  .r-block-title {
    margin-bottom: 8px;
    padding-left: 4px;
    text-transform: none;
    font-size: 12px;
    letter-spacing: initial;
    &:before {
      content: none;
    }
  }
  .el-input__inner {
    padding-left: 32px;
  }
  .r-input__filter-icons {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 12px;
    height: calc(100% - 8px);
    width: 12px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
  }
  .r-input__icons {
    width: 16px;
    left: auto;
    right: 8px;
  }
}
</style>

<i18n>
{
  "ru": {
    "datasources:title-user-ds": "Список всех источников данных",
    "datasources:title-activeuser-ds": "Выбранные источники данных",
    "datasources:title-activeuser-ds-nonmanaged": "Другие источники данных доступные ",

    "datasources:no-data": "Источники данных отсутствуют",
    "datasources:filter-no-data": "По вашему запросу источники данных отсутствуют",
    "crud:create": "создание",
    "crud:read": "чтение",
    "crud:update": "обновление",
    "crud:delete": "удаление",
    "crud:share": "управление",
    "crud:export": "экспорт"
  },
  "en": {
    "datasources:title-user-ds": "List all data sources",
    "datasources:title-activeuser-ds": "Selected data sources",
    "datasources:title-activeuser-ds-nonmanaged": "Other data sources available ",

    "datasources:no-data": "No data sources available",
    "datasources:filter-no-data": "No data sources available for your request",
    "crud:create": "create",
    "crud:read": "read",
    "crud:update": "update",
    "crud:delete": "delete",
    "crud:share": "manage",
    "crud:export": "export"
  }
}
</i18n>
